import EstimateAllocateUtils from "./estimate-allocate-utils";
import formatDate from "../format/date";

const Format = {

    // USER DATE TIME FORMAT
    dateUserFormat(moment: Moment) {
        console.warn('Depricated - use formatDate import from core/gd/format/date')
        return formatDate(moment)

        // OLD
        // let format = gd.session.me.formatSettings.date;
        //
        // // this is experimental patch available only here... if old year show old year
        // if (format === 'MMM D' && moment.year()!==Moment().year()) format = "MMM D, YYYY"
        //
        // return moment.format(format);
    },

    datetimeUserFormat(moment: Moment) {
        return moment.format(gd.session.me.formatSettings.datetime);
    },

    timeUserFormat(moment: Moment) {
        return moment.format(gd.session.me.formatSettings.time);
    },

    //


    number(value: any, decimalPlaces = 2, addCommas = false) {

        let normalized: any = typeof value === 'number' ? value.toFixed(decimalPlaces) : parseFloat(value).toFixed(decimalPlaces);
        normalized = isNaN(normalized) ? 0 : normalized;

        if (addCommas) {
            let parts = normalized.toString().split(".");
            return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") + (parts[1] ? "." + parts[1] : "");
        }

        return normalized;
    },

    currency(value: number, decimalPlaces = 2, addCommas = false) {
        return Format.number(value, decimalPlaces, addCommas)
    },

    date(value: Moment, format: string, humanLabels=false) {

        let result = value.format(format);

        if (humanLabels) {
            const today = moment();

            if (value.diff(today,'days')===0) result = 'Today';
            if (value.diff(today,'days')===1) result = 'Tomorrow';
            if (value.diff(today,'days')===-1) result = 'Yesterday';

        }

        return result;
    },

    specialCharactersToHtml(str: string) {
        return str.replace(/&amp;/g, "&").replace(/&gt;/g, ">").replace(/&lt;/g, "<").replace(/&quot;/g, "\"");
    },

    time(moment: Moment, format = null) {

        if (!format) {
            format = gd.session.me.formatSettings.time;
        }

        if (!moment) {
            console.warn("fromat-123 no moment passed");
            return '';
        }

        return moment.format(format!);

    },

    workWeekInObjectFormat(workweekArray: any[]) {
        return {
            'mon': !!workweekArray[0],
            'tue': !!workweekArray[1],
            'wed': !!workweekArray[2],
            'thu': !!workweekArray[3],
            'fri': !!workweekArray[4],
            'sat': !!workweekArray[5],
            'sun': !!workweekArray[6]
        };
    },

    minutesToHoursDecimal(minutes: number) {

        return EstimateAllocateUtils.minutesToHours(minutes,2)

    }
}

export default Format
